import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, signal } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormField } from 'src/app/shared/form/abstracts';
import { StructureField } from 'src/app/shared/modular-survey/interfaces';
import { ModularSurveyForm } from 'src/app/shared/modular-survey/services';

@Component({
  selector: 'app-multiple-response-field-wrapper',
  templateUrl: './multiple-response-field-wrapper.component.html',
  styleUrls: ['./multiple-response-field-wrapper.component.scss'],
  standalone: true,
  imports: [
    TranslateModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: MultipleResponseFieldWrapperComponent
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultipleResponseFieldWrapperComponent extends BaseFormField<string[]> {
  // Inputs
  public field = input<StructureField>();
  public form = input.required<FormGroup>();
  public formControlName = input.required<string>();
  
  // Service injections
  private _cdr = inject(ChangeDetectorRef);
  private _modularSurveyFormService = inject(ModularSurveyForm);
  
  // Computed properties
  protected formControl = computed(() => this.form().get(this.formControlName()));
  
  // Local signal states
  protected showErrorMessage = signal<boolean>(false);

  // Local properties
  private _optionListSelected: Set<string> = new Set<string>();
  
  // Effects
  markAllFieldsAsTouched = effect(() => {
    const control = this.formControl();
    this._markFieldsAsTouched(control, this._cdr);
  }, { allowSignalWrites: true });

  // Methods
  protected handleCheckboxChange(event: Event): void {
    const customEvent = event as CustomEvent<{ name: string, value: string, checked: boolean}>;
    const selectedOption = customEvent.detail.value;
    
    if (customEvent.detail.checked) {
      this._optionListSelected.add(selectedOption);
    } else {
      this._optionListSelected.delete(selectedOption);
    }    
    
    const OptionListSelectedArray = Array.from(this._optionListSelected);
    if(OptionListSelectedArray.length === 0) {
      this.showErrorMessage.set(true);
      return;
    } else {
      this.showErrorMessage.set(false);
    }
    
    this.formControl().setValue(OptionListSelectedArray);
  }
  
  private _markFieldsAsTouched(control: AbstractControl | null, cdr: any): void {
    if (this._modularSurveyFormService.markAllFormFieldsAsTouched()) {
      this._modularSurveyFormService.markFieldAsTouched(control);

      if (this._modularSurveyFormService.isInvalidField(control)) {
        this.showErrorMessage.set(true);
      }
      cdr.detectChanges();
    }
  }
}
